import footer from "./footer.json";

export default {
    french: "Френски",
    footer,
};
